import * as React from 'react';

import FilePhotoshop16 from './FilePhotoshop16';

export const filePhotoshop16 = () => <FilePhotoshop16 />;

export default {
    title: 'Icon/Fill/FilePhotoshop16',
    component: FilePhotoshop16,
    parameters: {
        notes: "`import FilePhotoshop16 from 'box-ui-elements/es/icon/fill/FilePhotoshop16';`",
    },
};
